import { gql, useLazyQuery } from '@apollo/client'

export type GetFieldSuggestionQuery = {
  getFieldSuggestion?: string[] | null
}

export type GetFieldSuggestionQueryVariables = {
  fieldName: string
  query: string
  limit?: number | null
}

export const GQL_QUERY_GET_FIELD_SUGGESTION = gql`
  query getFieldSuggestion($fieldName: String!, $query: String!, $limit: Int) {
    getFieldSuggestion(fieldName: $fieldName, query: $query, limit: $limit)
  }
`

export const useLazyFetchFieldSuggestion = () =>
  useLazyQuery<GetFieldSuggestionQuery, GetFieldSuggestionQueryVariables>(
    GQL_QUERY_GET_FIELD_SUGGESTION,
    {
      fetchPolicy: 'network-only',
    },
  )
